import _ from 'lodash'

export default class DataFormat {
  constructor (args = {}) {
    const defaults = {
      dataType: '',
      dataformat: 'DA',
      decimalDigits: 0,
      roundWay: '',
      width: '',
      // 对齐方式
      align: 'center'
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/dataFormat.js